import React from 'react';
import styled from 'styled-components/macro';
import Slider from 'react-slick';
import CarouselContainer from './CarouselContainer';

const StyledCarousel = styled(CarouselContainer)`
  & .slick-arrow {
    z-index: 2;
  }
  & .slick-prev:before, & .slick-next:before {
    color: ${({ theme }) => theme.colors.colorGreyLightAlt};
  }
  & .slick-prev:hover:before, & .slick-next:hover:before {
    color: ${({ theme }) => theme.colors.colorGreyDark};
  }
`;

const ImageSlider = ({ productView1, children, ...props }) => {
  const settings = {
    dots: !productView1,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  return (
    <StyledCarousel productView1={productView1} {...props}>
      <Slider {...settings}>
        {children}
      </Slider>
    </StyledCarousel>
  );
};

export default ImageSlider;
